// Design tokens for the host onboarding flow (ported from the Lovable "new host UI").
export const ob = {
  bg: '#ffffff',
  surface: '#fdfcfb',
  card: '#ffffff',
  text: '#1a1a1a',
  muted: '#6b6b6b',
  mutedBg: '#f1eee8',
  border: '#eeebe6',
  borderStrong: '#e0dcd3',
  primary: '#ff710f',
  primarySoft: '#fff0e6',
  primaryText: '#ffffff',
  danger: '#be123c',
  success: '#2e7d32',
  successSoft: '#e8f5e9',
  warning: '#b45309',
  warningSoft: '#fff7ed',
  ring: 'rgba(255, 113, 15, 0.35)',
  shadowCard: '0 1px 2px rgba(26,26,26,0.03), 0 10px 30px rgba(26,26,26,0.055)',
  shadowStrong: '0 2px 4px rgba(26,26,26,0.04), 0 18px 48px rgba(26,26,26,0.10)',
  shadowBrand: '0 10px 24px rgba(255,113,15,0.24)',
  fontDisplay: "'Plus Jakarta Sans', 'Poppins', ui-sans-serif, system-ui, sans-serif",
  fontBody: "'Inter', 'Poppins', ui-sans-serif, system-ui, sans-serif",
};

export const bp = {
  sm: '@media (min-width: 640px)',
  md: '@media (min-width: 768px)',
  lg: '@media (min-width: 1024px)',
};

/** Rail sections, in the order the host walks through the existing onboarding routes. */
export const ONBOARDING_SECTIONS = [
  'Property information',
  'About the stay',
  'Location',
  'Amenities',
  'Photos & video',
  'Pricing',
  'Booking & payment',
  'House rules',
  'Pricing Plan',
  'Review',
] as const;

export type OnboardingSection = (typeof ONBOARDING_SECTIONS)[number];

/** Rail for the "Let us list it for you" (import) flow. */
export const IMPORT_SECTIONS = [
  'Import',
  'Verify',
  'Pricing Plan',
  'Review',
  'Submit',
] as const;
